import { render, staticRenderFns } from "./edit-delta.vue?vue&type=template&id=063e2044&scoped=true"
import script from "./edit-delta.vue?vue&type=script&lang=js"
export * from "./edit-delta.vue?vue&type=script&lang=js"
import style0 from "./edit-delta.vue?vue&type=style&index=0&id=063e2044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e2044",
  null
  
)

export default component.exports